import * as types from './actionTypes';

export const setModalInfo = (fio, paySum, payDate, refundSum, refundDate, allRefunds) => (
    {
        type: types.SET_MODAL_INFO,
        fio,
        paySum,
        payDate,
        refundSum,
        refundDate,
        allRefunds,
    }
);


// WEBPACK FOOTER //
// ./src/js/store/modal/actions.js